/*!
 * sub.js — sub:{...}: an octave pedal's sub, under a synth's voice
 * © 2026 Rob Canning — GPLv3
 *
 *     sub:0.8                           an octave down, at 0.8 of the sound's level
 *     sub:{level:1, octave:2, tone:0.2} two octaves down, rounder
 *
 *   level   0..2 (0.8)  how much sub, under the dry sound
 *   octave  1 | 2 (1)   one octave down, or two
 *   tone    0..1 (0.5)  0 a round near-sine .. 1 brighter, more of the square
 *
 * First in the voice: before drive:, fuzz: and the envelope (synth.js), as
 * an octave pedal before a fuzz. It finds the pitch in the wave itself, so
 * it follows patterns, glides, follow() and sinOsc() as they play. The
 * sound is subCore.js, in the audio engine (subWorklet.js, workletFx.js).
 */

import { subSettings } from "./subCore.js";
import { loadWorklet, buildWorkletFx } from "./workletFx.js";

const URL_ = new URL("./subWorklet.js", import.meta.url).href;

/** Load the sub into this context's audio engine (once). */
export const loadSub = ctx => loadWorklet(ctx, URL_);

/** A sub for one voice (or, channels 2, an fx bus): { input, output, set(cfg), stop() }. */
export function buildSub(ctx, cfg, channels = 1) {
  const fx = buildWorkletFx(ctx, { processor: "oscilla-sub", url: URL_, settings: subSettings(cfg), channels });
  return { ...fx, set: c => fx.set(subSettings(c)) };
}
